module.exports = __webpack_public_path__ + "static/img/ais.cb78db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ais.jpg
// module id = p5rX
// module chunks = 0